import React from "react";

//component
import JobList from "../../../../topmenu/job/helper/component/JobList.js";

//icon toggler
//import IconToggler from "../../../components/Icon/";

export default class JobsScreen extends React.Component {
  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          {/* START Book a tool */}
          <div className="col-md-12">
              <JobList {...this.props} />
          </div>
          {/* END */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/job/job.js